// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#authentication-navigation.navigation-block.authenticated {
    /*padding: 13px 0; */
}

#authentication-navigation {
    position: relative;
    cursor: pointer;
    white-space: nowrap;
}
#authentication-navigation svg {
    display: inline-block;
    width: 18px;
    height: 18px;
    margin-right: 6px;
    margin-bottom: -4px;
}
#authentication-navigation .profile-image svg {
    display: inline-block;
    width: 30px;
    height: 30px;
}
#authentication-navigation .profile-image img {
    display: inline-block;
    height: 30px;
    margin-right: 6px;
}
#authentication-navigation .navigation-text {
    display: inline-block;
    padding: 0 5px;
}
#authentication-navigation svg.arrow {
    width: 14px;
    height: 14px;
    margin-left: -2px;
    margin-bottom: -2px;
}

#authentication-navigation .logged-in-user {
    display: inline-block;
    text-align: left;
    white-space: nowrap;
}
#authentication-navigation.not-authenticated {
    padding: 0;
}
#authentication-navigation.not-authenticated a:link, 
#authentication-navigation.not-authenticated a:active, 
#authentication-navigation.not-authenticated a:visited,
#authentication-navigation.not-authenticated a:hover {
    padding: 5px;
    margin: 0 5px;
}

#authentication-navigation a.logout:link, 
#authentication-navigation a.logout:active, 
#authentication-navigation a.logout:visited,
#authentication-navigation a.logout:hover {
    padding: 5px;
    margin: 0 5px;
}

@media (width < 700px) {
    #authentication-navigation .navigation-text {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./client/components/header/navigation/AuthenticationNavigation.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;;;;IAII,YAAY;IACZ,aAAa;AACjB;;AAEA;;;;IAII,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":["#authentication-navigation.navigation-block.authenticated {\n    /*padding: 13px 0; */\n}\n\n#authentication-navigation {\n    position: relative;\n    cursor: pointer;\n    white-space: nowrap;\n}\n#authentication-navigation svg {\n    display: inline-block;\n    width: 18px;\n    height: 18px;\n    margin-right: 6px;\n    margin-bottom: -4px;\n}\n#authentication-navigation .profile-image svg {\n    display: inline-block;\n    width: 30px;\n    height: 30px;\n}\n#authentication-navigation .profile-image img {\n    display: inline-block;\n    height: 30px;\n    margin-right: 6px;\n}\n#authentication-navigation .navigation-text {\n    display: inline-block;\n    padding: 0 5px;\n}\n#authentication-navigation svg.arrow {\n    width: 14px;\n    height: 14px;\n    margin-left: -2px;\n    margin-bottom: -2px;\n}\n\n#authentication-navigation .logged-in-user {\n    display: inline-block;\n    text-align: left;\n    white-space: nowrap;\n}\n#authentication-navigation.not-authenticated {\n    padding: 0;\n}\n#authentication-navigation.not-authenticated a:link, \n#authentication-navigation.not-authenticated a:active, \n#authentication-navigation.not-authenticated a:visited,\n#authentication-navigation.not-authenticated a:hover {\n    padding: 5px;\n    margin: 0 5px;\n}\n\n#authentication-navigation a.logout:link, \n#authentication-navigation a.logout:active, \n#authentication-navigation a.logout:visited,\n#authentication-navigation a.logout:hover {\n    padding: 5px;\n    margin: 0 5px;\n}\n\n@media (width < 700px) {\n    #authentication-navigation .navigation-text {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
